import { authHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate, captureOnSuccess } from '@helpers/product-events';

export const formsService = {
    getAll,
    saveForm,
    deleteForm,
    exportSubmissions,
};

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/forms`, requestOptions).then(handleResponse);
}

function saveForm(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/forms`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.FormCreated));
}

function deleteForm(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/forms/${id}`, requestOptions).then(handleResponse);
}

function exportSubmissions(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/forms/${id}/submissions/export`, requestOptions)
        .then(handleResponseBlob)
        .then(captureOnSuccess(ProductEvent.DataExported, { resource: 'form_submissions' }));
}
